var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_262_1594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5881 3.91797V7.87797C14.5881 8.14053 14.6924 8.39234 14.8781 8.578C15.0638 8.76367 15.3156 8.86797 15.5781 8.86797H19.5381",
    stroke: "#1BA56F",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5582 21.738H7.65822C7.13309 21.738 6.62947 21.5294 6.25815 21.158C5.88683 20.7867 5.67822 20.2831 5.67822 19.758V5.89797C5.67822 5.37284 5.88683 4.86922 6.25815 4.4979C6.62947 4.12658 7.13309 3.91797 7.65822 3.91797H14.5882L19.5382 8.86797V19.758C19.5382 20.2831 19.3296 20.7867 18.9583 21.158C18.587 21.5294 18.0834 21.738 17.5582 21.738Z",
    stroke: "#1BA56F",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6084 11.8398V17.7798",
    stroke: "#1BA56F",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1331 14.3148L12.6081 11.8398L15.0831 14.3148",
    stroke: "#1BA56F",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_262_1594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.76,
    height: 23.76,
    fill: "white",
    transform: "translate(0.728516 0.951172)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.8cd904cf87bf31945f52c3fe96ee9a4f.svg";
export { ForwardRef as ReactComponent };